import React from 'react';
import { useTranslation } from 'react-i18next';
import { SkeletonPlaceholder } from '@modernhealth/vital-components';

import { BackButton } from '../components/BackButton';
import { Page } from '../components/PageLayout';
import { CircleCenteredBanner } from '../components/CircleCenteredBanner';
import { CirclesErrorFallback } from '../components/CirclesErrorFallback';
import { CirclesRenderScreenSectionNode } from '../components/CirclesRenderScreenSectionNode';
import { useCirclesLanguageOverviewScreenQuery } from '../documents/circlesLanguageOverviewScreen.generated';
import { languageCodes } from '../utils/languageCodes';

import { CirclesOnDemandByLanguageSectionSkeleton } from './CirclesOnDemandOverviewPage';

export const CirclesLanguagesPage = () => {
    const { t } = useTranslation('circles');
    const { data, loading } = useCirclesLanguageOverviewScreenQuery();

    if (loading) {
        return (
            <Page.Container>
                <Page.Header>
                    <BackButton>
                        {previousRoute => {
                            if (previousRoute === '/circles') {
                                return t('routes.fallback.title');
                            }

                            return null;
                        }}
                    </BackButton>
                </Page.Header>

                <Page.Content
                    css={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 40,
                    }}
                >
                    <SkeletonPlaceholder width="100%" height={134} />
                    {languageCodes.map(languageCode => (
                        <CirclesOnDemandByLanguageSectionSkeleton
                            key={languageCode}
                            languageCode={languageCode}
                        />
                    ))}
                </Page.Content>
            </Page.Container>
        );
    }

    if (data?.circlesLanguageOverviewScreen?.__typename === 'CirclePermissionDeniedError') {
        return <CirclesErrorFallback />;
    }

    return (
        <Page.Container>
            <Page.Header>
                <BackButton>
                    {previousRoute => {
                        if (previousRoute === '/circles') {
                            return t('routes.fallback.title');
                        }

                        return null;
                    }}
                </BackButton>
            </Page.Header>

            <Page.Content
                css={{
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 40,
                }}
            >
                <CircleCenteredBanner
                    header={
                        data?.circlesLanguageOverviewScreen?.name || t('pages.on_demand.hero.title')
                    }
                    description={
                        data?.circlesLanguageOverviewScreen?.description ||
                        t('pages.on_demand.hero.description')
                    }
                />

                {data?.circlesLanguageOverviewScreen?.sections.map(section => {
                    return <CirclesRenderScreenSectionNode key={section?.id} section={section} />;
                })}
            </Page.Content>
        </Page.Container>
    );
};
